(function () {
    'use strict';

    run.admin.parts.rackootRelocateTools = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const draggable_tiles = document.querySelectorAll('#tool_group__active .tool:not(#btn_new_menu)');
        const draggable_destinations = document.querySelectorAll('#rackoots_nav .rackoot__item.rackoot_tiles_target');

        if (draggable_tiles !== null) {
            for (let i = 0; i < draggable_tiles.length; i++) {
                // Start
                draggable_tiles[i].addEventListener("dragstart", function(e) {
                    // e.preventDefault();
                    e.originalTarget.classList.add("dragging");
                    for (let i = 0; i < draggable_destinations.length; i++) {
                        // if (e.originalTarget.dataset.rackootUuid != draggable_destinations[i].dataset.rackootUuid) {
                            draggable_destinations[i].classList.add("drop_target_active");
                        // }
                        // else {
                        //     draggable_destinations[i].classList.add("drop_target_is_self");
                        // }
                    }
                }, true);

                // Stop
                draggable_tiles[i].addEventListener("dragend", function(e) {
                    // e.preventDefault();
                    if (e.originalTarget.classList.contains("dragging")) {
                        e.originalTarget.classList.remove("dragging");
                    }
                    for (let i = 0; i < draggable_destinations.length; i++) {
                        draggable_destinations[i].classList.remove("drop_target_active");
                        draggable_destinations[i].classList.remove("drop_target_is_self");
                    }
                }, true);
            }
        }

        if (draggable_destinations !== null) {
            for (let i = 0; i < draggable_destinations.length; i++) {
                // Drag another item over
                draggable_destinations[i].addEventListener("dragover", function(e) {
                    e.preventDefault();
                    const dragged_item = document.querySelector('.dragging.tool');
                    if (dragged_item == null || dragged_item == 'undefined') { return }
                    if (dragged_item.dataset.rackootUuid == draggable_destinations[i].dataset.rackootUuid) {
                        draggable_destinations[i].classList.add("drop_forbidden");
                        dragged_item.classList.add("drop_forbidden");
                    } else {
                        draggable_destinations[i].classList.add("drop_ready");
                    }
                }, true);

                // Stop drag over
                draggable_destinations[i].addEventListener("dragleave", function(e) {
                    // e.preventDefault();
                    const dragged_item = document.querySelector('.dragging.tool');
                    if (dragged_item == null || dragged_item == 'undefined') { return }
                    draggable_destinations[i].classList.remove("drop_ready");
                    draggable_destinations[i].classList.remove("drop_forbidden");
                    dragged_item.classList.remove("drop_forbidden");
                }, true);

                // Drop an element inside
                draggable_destinations[i].addEventListener("drop", function(e) {
                    e.preventDefault();
                    const dragged_item = document.querySelector('.dragging.tool');
                    if (dragged_item == null || dragged_item == 'undefined') { return }
                    dragged_item.classList.remove("drop_forbidden");
                    draggable_destinations[i].classList.remove("drop_ready");
                    draggable_destinations[i].classList.remove("drop_forbidden");
                    draggable_destinations[i].classList.add("dropped");
                    
                    const destiny = e.currentTarget;

                    if (destiny.dataset.rackootUuid == dragged_item.dataset.rackootUuid) {
                        return false;
                    }

                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('tile_uuid', dragged_item.dataset.toolUuid);
                    data.append('rackoot_uuid', destiny.dataset.rackootUuid);

                    dragged_item.classList.add('d-none');
                    axios.post(GlobalRoutes.tools.relocate, data)
                    .then(function (response) {
                        dragged_item.remove();
                    })
                    .catch(function (error) {
                        dragged_item.classList.remove('d-none');
                        // console.log(error);
                        // new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    });
                }, true);
            }
        }
    }
})();
